<template>
  <div id="navbar">
    <div class="pc-nav-bar">
      <div>
        <div
          :class="['item', navbarIndex == -1 ? 'selected' : '']"
          @mouseover="hoverfun(-1)"
          @click="jumppage('/')"
        >
          <p
            :class="[
              'icon',
              navbarIndex == -1 || mouseIndex == -1
                ? 'icon-work-table-on'
                : 'icon-work-table',
            ]"
          ></p>
          <p>工作台</p>
        </div>
        <div class="loginbox" v-show="!login">
          <div>
            <img
              src="data:image/png;base64,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"
            />
          </div>
          <div class="login" @click="loginbox = true">登录/注册</div>
        </div>
        <div class="itemtable" v-show="login">
          <div
            v-for="(item, index) in navbar"
            :key="index"
            :class="['item', navbarIndex == index ? 'selected' : '']"
            @mouseover="hoverfun(index)"
            @click="jumppage(item.router)"
          >
            <p
              :class="[
                'icon',
                navbarIndex == index || mouseIndex == index
                  ? item.iconClass_on
                  : item.iconClass,
              ]"
            ></p>
            <p>{{ item.name }}</p>
          </div>
        </div>
        <div
          class="item"
          @mouseover="hoverfun(-2)"
          @click="dialogVisible = true"
          v-show="login"
        >
          <p
            :class="[
              'icon',
              navbarIndex == -2 || mouseIndex == -2
                ? 'icon-member-on'
                : 'icon-member',
            ]"
          ></p>
          <p>购买会员</p>
        </div>
        <div class="item" @mouseover="hoverfun(-3)" @click="modalstatus=true" v-show="login">
          <p
            :class="[
              'icon',
              navbarIndex == -3 || mouseIndex == -3
                ? 'icon-recommend-on'
                : 'icon-recommend',
            ]"
          ></p>
          <p>推荐有奖</p>
        </div>
      </div>

      <!-- 占位标签 -->
      <div style="flex: 1 0 10%"></div>

      <div class="coupons" v-if="couponsStatus && login">
        <img src="@/assets/navbar/coupons.png" alt="" />
        <i class="flash-across"></i>
        <svg
          @click="closeCoupons"
          data-v-d7e0d1d1=""
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1024 1024"
        >
          <path
            fill="currentColor"
            d="M764.288 214.592 512 466.88 259.712 214.592a31.936 31.936 0 0 0-45.12 45.12L466.752 512 214.528 764.224a31.936 31.936 0 1 0 45.12 45.184L512 557.184l252.288 252.288a31.936 31.936 0 0 0 45.12-45.12L557.12 512.064l252.288-252.352a31.936 31.936 0 1 0-45.12-45.184z"
          ></path>
        </svg>
      </div>
      <div class="website">
        <p>
          Copyright © 2024 版权所有：<span
            >{{ website.web_company }} | {{ website.web_beian }}</span
          >
        </p>
        <!-- <p>特聘法律顾问：{{ website.lawer }}</p> -->
      </div>
    </div>
    <membertc v-if="dialogVisible" @closemember="closemember"></membertc>
    <login v-if="loginbox" @closelogin="closelogin"></login>
    <invitetc :modalstatus="modalstatus" @closepoint="closepoint"/>
  </div>
</template>

<script>
import { indexConfig } from "@/api/login";
import invitetc from '@/components/invitetc'
import login from '@/components/login'
import membertc from '@/components/membertc'
export default {
  components:{
    invitetc,
    login,
    membertc
  },
  props: {
    navbarIndex: {
      type: Number,
      default: -1,
    },
  },
  data() {
    return {
      modalstatus:false,
      loginbox: false,
      login: false,
      dialogVisible: false,
      couponsStatus: true,
      mouseIndex: -4,
      navbar: [
        {
          name: "创作历史",
          iconClass: "icon-create-history",
          iconClass_on: "icon-create-history-on",
          router: "/history/2",
        },
        {
          name: "我的订单",
          iconClass: "icon-order",
          iconClass_on: "icon-order-on",
          router: "/order",
        },
        {
          name: "分钟数记录",
          iconClass: "icon-point",
          iconClass_on: "icon-point-on",
          router: "/point",
        },
        {
          name: "账号设置",
          iconClass: "icon-account",
          iconClass_on: "icon-account-on",
          router: "/account",
        },
		{
		  name: "公司官网",
		  iconClass: "icon-point",
		  iconClass_on: "icon-point-on",
		  router: "gw",
		},
      ],
      website: this.$store.website
    };
  },
  mounted() {
    if(localStorage.getItem('gpt-token')){
      this.login = true
    }else{
      this.login = false
    }
    
    if(localStorage.getItem('loginStatus')==0&&window.innerWidth>1000){
      console.log(localStorage.getItem('loginStatus'),window.innerWidth)
      this.loginbox = true
      localStorage.setItem('loginStatus',1)
    }
    // indexConfig().then(res=>{
    //   this.website = res.data
    // })
  },
  methods: {
    closemember(){
      this.dialogVisible = false
    },
    showpoint(){
      this.modalstatus=true
      this.$stopScroll()
    },
    closelogin(){
      this.loginbox=false
    },
    closepoint(){
      this.modalstatus=false
    },
    hoverfun(index) {
      this.mouseIndex = index;
    },
    closeCoupons() {
      this.couponsStatus = false;
    },
    jumppage(router) {
		if(router =='gw') {
			window.open(this.$store.website.web_company_official_website);
			return;
		}
      this.$router.push({ path: router });
    },
  },
};
</script>

<style lang="less">
@keyframes changeImg {
  from {
    left: -1800%;
  }
  to {
    left: 100%;
  }
}
#navbar {
  .loginbox {
    display: flex;
    align-items: center;
    flex-direction: column;
    padding-top: 40%;
    .login {
      cursor: pointer;
      width: 95px;
      height: 32px;
      background: #f1f1f1;
      border-radius: 3px;
      color: #1d2129;
      margin-top: 17px;
      font-size: 14px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .pc-nav-bar {
    width: 232px;
    height: calc(100vh - 60px);
    background: #ffffff;
    display: flex;
    flex-direction: column;
    position: relative;
    padding: 16px;
    border-right: 1px solid #f4f5f7;
    display: flex;
    flex-direction: column;
    .icon {
      background: url(../../assets/ai-pc-icon-6fdc37eb.png) no-repeat;
      display: inline-block;
      width: 20px;
      height: 20px;
      margin-right: 16px;
    }
    .icon-work-table {
      background-position: -29px -44px;
    }
    .icon-create-history {
      background-position: -241px -259px;
    }
    .icon-order {
      background-position: -299px -261px;
    }
    .icon-point {
      background-position: -129px -261px;
    }
    .icon-account {
      background-position: -74px -261px;
    }
    .icon-member {
      background-position: -224px -46px;
    }
    .icon-recommend {
      background-position: -281px -46px;
    }

    .icon-work-table-on {
      background-position: -1px -44px;
    }
    .icon-create-history-on {
      background-position: -269px -259px;
    }
    .icon-order-on {
      background-position: -327px -261px;
    }
    .icon-point-on {
      background-position: -157px -261px;
    }
    .icon-account-on {
      background-position: -102px -261px;
    }
    .icon-member-on {
      background-position: -252px -46px;
    }
    .icon-recommend-on {
      background-position: -307px -46px;
    }

    .itemtable {
      border-top: 1px solid #f4f5f7;
      border-bottom: 1px solid #f4f5f7;
      padding: 16px 0;
      margin: 16px 0;
    }

    .item {
      display: flex;
      align-items: center;
      height: 48px;
      border-radius: 4px;
      color: #4e5969;
      padding: 0 20px;
      cursor: pointer;
      font-weight: 400;
      font-size: 14px;
      line-height: 22px;
      color: #4e5969;
    }
    .item:hover {
      color: #2d8af5;
      background: #f5f9ff;
      border-radius: 4px;
    }

    .selected {
      color: #2d8af5;
      background: #f5f9ff;
      border-radius: 4px;
    }

    .coupons {
      position: relative;
      img {
        width: 100%;
        display: block;
      }
      svg {
        position: absolute;
        top: 0;
        right: 0;
        height: 1em;
        width: 1em;
        background-color: rgba(0, 0, 0, 0.4);
        color: #fff;
        cursor: pointer;
      }
      .flash-across {
        position: absolute;
        animation: changeImg 2s ease 0s;
        top: 0;
        width: 30%;
        height: 100%;
        content: "";
        background: linear-gradient(
          to right,
          rgba(255, 255, 255, 0) 0,
          rgba(255, 255, 255, 0.4) 50%,
          rgba(255, 255, 255, 0) 100%
        );
        transform: skewX(-45deg);
        animation-iteration-count: infinite;
      }
    }

    .website {
      margin-top: 16px;
      border-top: 1px solid #f4f5f7;
      p {
        font-size: 12px;
        color: #999;
        padding-top: 8px;
        text-align: justify;
      }
    }
  }
}
</style>